var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "file-chooser-empty",
    },
    [
      _c("studip-icon", {
        attrs: {
          shape: "folder-empty",
          size: 128,
          role: "inactive",
        },
      }),
      _vm._v("\n    " + _vm._s(_vm.$gettext("Dieser Ordner ist leer")) + "\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }